import { render } from "./PaymentsManagerSettingsList.vue?vue&type=template&id=5db7de15&scoped=true"
import script from "./PaymentsManagerSettingsList.vue?vue&type=script&lang=js"
export * from "./PaymentsManagerSettingsList.vue?vue&type=script&lang=js"

import "./PaymentsManagerSettingsList.vue?vue&type=style&index=0&id=5db7de15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db7de15"]])

export default __exports__